module.exports = __webpack_public_path__ + "img/sixpackcarrier64.a020007f.jpg";